/**
 * @field SCHEMA - Upload a file to be used as the basis for a schema
 * @field TEST - Upload a file to be used to test a schema
 */
export enum UploadFileType {
  SCHEMA,
  TEST,
}
